import React from "react";
import SpravSearchBar from "./SpravSearchBar";

/**
 * Обёртка над SpravSearchBar для использования в шапке страницы /Hotel-sprav
 * и в шапке /Sprav. Сохраняет всю логику searchStore / navigate / живого поиска.
 *
 * Отличия от прямого использования SpravSearchBar:
 * - не задаёт внешние отступы и max-width (родитель сам управляет шириной)
 * - принимает accentColor (пока не используется, задел на будущее)
 * - экспортируется как default из отдельного файла — чтобы страницы
 *   отеля и /Sprav не зависели напрямую от SpravSearchBar
 */
export default function HeaderSearchField({
  accentColor = "#14b8a6",
  ...props
}) {
  return (
    <div className="w-full">
      <SpravSearchBar variant="sprav" {...props} />
    </div>
  );
}
